module.exports = __webpack_public_path__ + "img/logo_loading.1d91cb03.gif";